// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"19b44742","466":"b9e1ef74","604":"637d7ea4","618":"58bc3167","720":"48050be5","812":"64869c8d","825":"705fdea4","903":"ace365de","979":"3d2f09c2"}[chunkId] + ".chunk.js";
};